// eslint-disable-next-line @nx/enforce-module-boundaries
import { AwardType } from '@occc-app/offerHelpers/types';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { routeCreator as awardRouteCreator } from '@occc-app/routes/AwardCatalog/utils';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { LinkChip } from '@occc-app/design-system';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { displayAmount } from '@occc-app/lib/currency';
import { Constraint_Purchase_Threshold_Counting_Attribute } from '@occc/graphql';

import { ConfigurationDetailsAward } from './configuration-details.types';

export const mapAwardToText = (award: ConfigurationDetailsAward) => {
  if (award.type === AwardType.AwardPoints) {
    return `${award.points} Points`;
  }
  if (award.type === AwardType.AwardVouchers) {
    return (
      <LinkChip
        label={award.voucheredOffer.name}
        href={awardRouteCreator.details(award.voucheredOffer.id)}
      />
    );
  }
  return 'Nothing';
};

export const formatThreshold = (params: {
  threshold: number;
  countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute;
}): string => {
  if (params.countProductsBy === Constraint_Purchase_Threshold_Counting_Attribute.MoneyAmount) {
    return displayAmount(params.threshold, true);
  }
  return params.threshold.toString();
};
